export const appZIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path d="M0 0H24V24H0z"/><path fill="currentColor" fill-rule="nonzero" d="M16 17L16 15.345 10.705 15.345 15.885 8.181 15.885 7 8.007 7 8.007 8.669 13.194 8.669 8 15.791 8 17z"/></g></svg>`,
    name: 'z' as const
};